/**
 * FeedbackWidget — thumbs up / down CSAT capture.
 *
 * Renders a simple "Was this helpful?" prompt with thumbs up/down buttons.
 * After the user votes, shows a thank-you confirmation and locks the buttons.
 * Designed to sit just above the reset/start-over button on ReviewPage.
 *
 * Props:
 *   context  {string}  optional label sent with the event (default: 'research_results')
 */

import React, { useState } from 'react';
import {
  Box,
  SpaceBetween,
  Button,
  StatusIndicator,
} from '@cloudscape-design/components';
import analyticsService from '../services/analyticsService';

export default function FeedbackWidget({ context = 'research_results' }) {
  const [voted, setVoted] = useState(null); // null | 'up' | 'down'

  function handleVote(rating) {
    if (voted) return;
    analyticsService.trackFeedback(rating, context);
    setVoted(rating);
  }

  return (
    <Box textAlign="center" padding={{ top: 'm', bottom: 's' }}>
      {!voted ? (
        <SpaceBetween direction="vertical" size="xs">
          <Box variant="small" color="text-body-secondary">
            Was this research helpful?
          </Box>
          <SpaceBetween direction="horizontal" size="xs">
            <Button
              iconName="thumbs-up"
              variant="normal"
              onClick={() => handleVote('up')}
              ariaLabel="Thumbs up — helpful"
            >
              Helpful
            </Button>
            <Button
              iconName="thumbs-down"
              variant="normal"
              onClick={() => handleVote('down')}
              ariaLabel="Thumbs down — not helpful"
            >
              Not helpful
            </Button>
          </SpaceBetween>
        </SpaceBetween>
      ) : (
        <StatusIndicator type="success">
          Thanks for your feedback!
        </StatusIndicator>
      )}
    </Box>
  );
}
